import { useCallback, useEffect, useState } from "react";
import {
  getSectionTextFromResultRequests
} from "@demandproai/shared";

const useDemandStudioSectionTexts = ({ sectionDefinitions, resultRequests }) => {
  const [sectionTexts, setSectionTexts] = useState({});

  useEffect(() => {
    if ( !resultRequests?.length || !sectionDefinitions.length) return;
    const texts = {};
    sectionDefinitions.forEach((section) => {
      texts[section.id] = getSectionTextFromResultRequests(resultRequests, section);
    });
    setSectionTexts(texts);
  }, [sectionDefinitions, resultRequests]);

  const updateSectionText = useCallback(
    ({ sectionId, value }) => {
      setSectionTexts((prev) => ({ ...prev, [sectionId]: value }));
    },
    [setSectionTexts]
  );

  const batchUpdateSectionTexts = useCallback(
    async (updates) => {
      setSectionTexts((prev) => {
        const next = { ...prev };
        updates.forEach(({ sectionId, value }) => {
          next[sectionId] = value;
        });
        return next;
      });
    },
    [setSectionTexts]
  );

  return {
    sectionTexts,
    updateSectionText,
    batchUpdateSectionTexts
  };
};

export default useDemandStudioSectionTexts;
